module.exports = __webpack_public_path__ + "console/img/百世.e057c973.jpg";